'use client';

import { ReactNode } from 'react';
import clsx from 'clsx';

import { Section } from '~/components';
import { Typography, IcChevronDown, theme, IcFilter } from '@bgzt/ui';

import styles from './FilterBubble.module.css';
import globalStyles from '~/styles/utils.module.css';

type BubbleData = {
  key: string;
  renderLabel: (value: unknown[]) => ReactNode;
  value: unknown[];
  placeholderLabel?: string;
  showsPlaceholder?: boolean;
  onClick?: (value: unknown[], key: string) => void;
};

type Props = {
  data: BubbleData[];
  selectedKeyShortcutKeys?: string[];
  onFilterIconClick?: () => void;
  isHighlighted?: boolean;
};

/**
 * @description 필터 버블 컴포넌트
 *
 * - data
 *  - key: 각 필터 구별 값
 *  - renderLabel: 보여질 내용 parameter로 value를 받는다
 *  - value: 해당 필터에 선택된 값
 *  - placeholderLabel: 필터에 선택된 값이 없을 떄, 나타낼 값
 *  - onClick: 클릭했을떄 Action (value, key) => void
 * - selectedKey: 선택된 key 값
 * - selectedFilterNumber: 필터 아이콘의 숫자를 표시합니다
 * - onFilterIconCLick: 필터 아이콘을 클릭했을때 Action
 */

export const FilterBubble = ({
  data,
  selectedKeyShortcutKeys = [],
  onFilterIconClick,
  isHighlighted = false,
}: Props) => {
  return (
    <Section className={styles.container}>
      <div className={clsx([styles.bubbleContainer, globalStyles.scrollXHidden])}>
        {data.map(
          ({ key, renderLabel, value, placeholderLabel, showsPlaceholder = false, onClick: onFilterBubbleClick }) => {
            const isSelected = selectedKeyShortcutKeys.includes(key);
            return (
              <button
                className={clsx([styles.filterButton, isSelected && styles.filterSelected])}
                key={key}
                onClick={() => {
                  onFilterBubbleClick?.(value, key);
                }}
              >
                <Typography as="p" variant={isSelected ? 'L9' : 'L10'} color="gray-900">
                  {showsPlaceholder || value.length === 0 ? placeholderLabel : renderLabel(value)}
                </Typography>
                <IcChevronDown size={12} fill={theme.colors['gray-900']} />
              </button>
            );
          },
        )}
      </div>
      <div className={styles.filterBottomSheetButtonContainer}>
        <button
          className={clsx([
            styles.filterButton,
            styles.filterBottomSheetButton,
            isHighlighted && styles.filterSelected,
          ])}
          onClick={() => {
            onFilterIconClick?.();
          }}
          data-testid="filter-icon"
        >
          <IcFilter size={14} />
        </button>
      </div>
    </Section>
  );
};
